import styled from 'vue-styled-components'

export default styled.div`
  .header-modal {
    background-color: #2962ff;
  }
`;
